/**
 * sourceScopeNote — the chat line that says which sources a regenerate reads
 * when the writer asked to "use only" some of them. Without it a request that
 * matched nothing in the library silently read the whole library.
 */

import type { RegenSourceScope } from "../../api/client";

export function sourceScopeNote(
  scope: RegenSourceScope | null | undefined,
  sectionLabel?: string | null,
): string | null {
  if (!scope?.restricted) return null;
  const where = sectionLabel ? ` for ${sectionLabel}` : "";
  if (scope.documents.length === 0) {
    return (
      `I couldn't match the sources you named to a document in the library, so the redraft${where} reads the whole ` +
      "library. Name the document as it appears in the library, or @-attach it, and regenerate again."
    );
  }
  return `The redraft${where} reads only: ${scope.documents.join("; ")}.`;
}
